import { UserManagementClient } from '@webdev/user-management';
import { definedOrThrows } from '@webdev/utils';
import React, { useContext } from 'react';

const context = React.createContext<UserManagementClient | undefined>(undefined);

export const UserManagementClientContext: React.FC<{
  userManagementClient: UserManagementClient;
}> = ({ userManagementClient, ...props }) => {
  return <context.Provider value={userManagementClient} {...props} />;
};

export const useUserManagementClientContext = () =>
  definedOrThrows(useContext(context), 'UserManagementClientContext');
